<style scoped>
  .numero {  height: 50px;  }
</style>

<template>
  <portal-box class="has-text-centered">

    <div class="numero">
      <portal-loading-small class="p-h-sm" :loading="loading" />

      <div v-if="!loading" class="animated fadeIn">
        <div class="is-size-2" v-if="valor"> {{ valor.toLocaleString() }} </div>
        <div class="is-size-2" v-else> - </div>
      </div>
    </div>

    <p> {{ texto }} </p>
  </portal-box>
</template>
<script>
  export default {
    props: ['valor', 'texto', 'loading']
  }
</script>



// WEBPACK FOOTER //
// src/components/Quadro.vue